// src/plugins/vuetify.js
import "material-design-icons-iconfont/dist/material-design-icons.css"; // Ensure you are using css-loader
import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
	icons: {
		iconfont: "md", // default - only for display purposes
	},
	theme: {
		themes: {
			light: {
				primary: "#715D00",
				surfaceTint: "#715D00",
				onPrimary: "#FFFFFF",
				primaryContainer: "#FFDF6C",
				onPrimaryContainer: "#554600",
				secondary: "#9C0535",
				onSecondary: "#FFFFFF",
				secondaryContainer: "#CF3656",
				onSecondaryContainer: "#FFFFFF",
				tertiary: "#006686",
				onTertiary: "#FFFFFF",
				tertiaryContainer: "#48B2DD",
				onTertiaryContainer: "#001F2B",
				error: "#BA1A1A",
				onError: "#FFFFFF",
				errorContainer: "#FFDAD6",
				onErrorContainer: "#410002",
				background: "#FFF8EF",
				onBackground: "#1E1B12",
				surface: "#FDF8F8",
				onSurface: "#1C1B1B",
				surfaceVariant: "#E6E1E7",
				onSurfaceVariant: "#48464B",
				outline: "#79767B",
				outlineVariant: "#CAC5CB",
				shadow: "#000000",
				scrim: "#000000",
				inverseSurface: "#313030",
				inverseOnSurface: "#F4F0EF",
				inversePrimary: "#E6C43C",
				primaryFixed: "#FFE176",
				onPrimaryFixed: "#231B00",
				primaryFixedDim: "#E6C43C",
				onPrimaryFixedVariant: "#554500",
				secondaryFixed: "#FFD9DC",
				onSecondaryFixed: "#400010",
				secondaryFixedDim: "#FFB2BA",
				onSecondaryFixedVariant: "#910030",
				tertiaryFixed: "#BFE8FF",
				onTertiaryFixed: "#001F2B",
				tertiaryFixedDim: "#6ED2FF",
				onTertiaryFixedVariant: "#004D65",
				surfaceDim: "#DDD9D8",
				surfaceBright: "#FDF8F8",
				surfaceContainerLowest: "#FFFFFF",
				surfaceContainerLow: "#F7F3F2",
				surfaceContainer: "#F1EDEC",
				surfaceContainerHigh: "#EBE7E6",
				surfaceContainerHighest: "#E5E2E1",
				n0: "#000000",
				n5: "#111111",
				n10: "#1C1B1B",
				n15: "#262625",
				n20: "#313030",
				n25: "#3C3B3B",
				n30: "#484646",
				n35: "#545252",
				n40: "#605E5E",
				n50: "#797676",
				n60: "#939090",
				n70: "#ADAAAA",
				n80: "#C9C6C5",
				n90: "#E5E2E1",
				n95: "#F4F0EF",
				n98: "#FDF8F8",
				n99: "#F6FEFF",
				n100: "#FFFFFF",
			},
			dark: {
				primary: "#FFFFFF",
				surfaceTint: "#E6C43C",
				onPrimary: "#3B2F00",
				primaryContainer: "#F5D24A",
				onPrimaryContainer: "#4C3E00",
				secondary: "#FFB2BA",
				onSecondary: "#67001F",
				secondaryContainer: "#AE1B41",
				onSecondaryContainer: "#FFFFFF",
				tertiary: "#6ED2FF",
				onTertiary: "#003547",
				tertiaryContainer: "#299CC7",
				onTertiaryContainer: "#000000",
				error: "#FFB4AB",
				onError: "#690005",
				errorContainer: "#93000A",
				onErrorContainer: "#FFDAD6",
				background: "#16130B",
				onBackground: "#E9E2D3",
				surface: "#141313",
				onSurface: "#E5E2E1",
				surfaceVariant: "#48464B",
				onSurfaceVariant: "#CAC5CB",
				outline: "#938F95",
				doutlineVariant: "#48464B",
				shadow: "#000000",
				scrim: "#000000",
				inverseSurface: "#E5E2E1",
				inverseOnSurface: "#313030",
				inversePrimary: "#715D00",
				primaryFixed: "#FFE176",
				onPrimaryFixed: "#231B00",
				primaryFixedDim: "#E6C43C",
				onPrimaryFixedVariant: "#554500",
				secondaryFixed: "#FFD9DC",
				onSecondaryFixed: "#400010",
				secondaryFixedDim: "#FFB2BA",
				onSecondaryFixedVariant: "#910030",
				tertiaryFixed: "#BFE8FF",
				onTertiaryFixed: "#001F2B",
				tertiaryFixedDim: "#6ED2FF",
				onTertiaryFixedVariant: "#004D65",
				surfaceDim: "#141313",
				surfaceBright: "#3A3939",
				surfaceContainerLowest: "#0E0E0E",
				surfaceContainerLow: "#1C1B1B",
				surfaceContainer: "#201F1F",
				surfaceContainerHigh: "#2B2A2A",
				surfaceContainerHighest: "#353434",
			},
		},
	},
});
